module.exports = __webpack_public_path__ + "static/img/search.1aa64b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons-actividad/search.png
// module id = 218
// module chunks = 1